import { simProdcutsSubscriptionStatusFilterAtom } from 'src/atoms/filters/sim-products';
import { SubscriptionStatusSelect } from 'src/common/components/SubscriptionStatus/SubscriptionStatusSelect';

export const SimProductsSuscriptionStatusInput = () => {
  return (
    <SubscriptionStatusSelect
      subscriptionStatusesFilterAtom={simProdcutsSubscriptionStatusFilterAtom}
    />
  );
};
